import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import clsx from 'clsx';
type ButtonGroupFilterContentProps = {
  className?: string;
  label: string;
  options: {
    label: ReactNode;
    value: string;
  }[];
  selected?: string[];
  onChange: (selected: string[] | undefined) => void;
};
export const ButtonGroupFilterContent = t0 => {
  const $ = _c(20);
  const {
    className,
    label,
    options,
    selected: t1,
    onChange
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const selected = t2;
  let t3;
  if ($[2] !== onChange || $[3] !== selected) {
    t3 = value => {
      const isCurrentlySelected = selected.includes(value);
      if (isCurrentlySelected) {
        const newSelected = selected.filter(s => s !== value);
        onChange(newSelected.length > 0 ? newSelected : undefined);
      } else {
        onChange([...selected, value]);
      }
    };
    $[2] = onChange;
    $[3] = selected;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleToggle = t3;
  let t4;
  if ($[5] !== className) {
    t4 = clsx("grid gap-2", className);
    $[5] = className;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== label) {
    t5 = <legend className="sr-only">{label}</legend>;
    $[7] = label;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== handleToggle || $[10] !== options || $[11] !== selected) {
    let t7;
    if ($[13] !== handleToggle || $[14] !== selected) {
      t7 = option => {
        const isSelected = selected.includes(option.value);
        return <label key={option.value} className={clsx("flex cursor-pointer items-center justify-center px-4 py-2 text-center text-sm font-semibold", "hover:bg-neutral-900 hover:text-white", "focus-within:shadow-[0_0_0_2px_var(--white)] focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-focus", isSelected ? "bg-black text-white" : "bg-neutral-100 text-black")}><input type="checkbox" className="sr-only" checked={isSelected} onChange={() => handleToggle(option.value)} /><span>{option.label}</span></label>;
      };
      $[13] = handleToggle;
      $[14] = selected;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    t6 = options.map(t7);
    $[9] = handleToggle;
    $[10] = options;
    $[11] = selected;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = <div className="w-full"><fieldset className={t4}>{t5}{t6}</fieldset></div>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};